import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import * as Yup from 'yup';
import { Form, Formik, Field } from 'formik';
import * as Icon from '@mui/icons-material/';
//import { createBrowserHistory } from 'history';
import { BoxButtons, Button } from '../../../Styles/ScreenStyle';
import { HeaderComponent } from '../../../../shared/components/HeaderComponent';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import BancoController from '../../../../controllers/BancoController';
import { toast } from 'react-toastify';
import { useLocation } from 'react-router-dom';

export default function BancoCadastrar() {
  const { id } = useParams();
  const bancoId = id ? parseInt(id, 10) : null;

  const { userId } = useSelector((state: any) => state.Authentication);
  //const history = createBrowserHistory();
  const navigate = useNavigate();
  const [single, setSingle] = useState<any>(null);
  const location = useLocation();
  const duploClick = location.state?.duploClick || false;

  useEffect(() => {
    if (bancoId !== null && bancoId !== undefined) {
      getSingle(bancoId);
    }
  }, [bancoId]);

  const getSingle = async (bancoId: number) => {
    const Response = await BancoController.ListarUnico(bancoId);
    setSingle(Response.Data);
  };

  const handleSubmit = async (
    values: any,
    { setSubmitting, resetForm }: any
  ) => {
    if (bancoId === null) {
      const response = await BancoController.Adicionar(values);

      if (response.StatusCode === 204) {
        toast('Banco incluido com sucesso!', {
          type: 'success',
        });
        resetForm();
      } else {
        toast('Erro ao incluir o banco!', {
          type: 'error',
        });
        resetForm();
      }
    } else {
      EditarContato(values, { setSubmitting, resetForm });
    }

    setSubmitting(false);
  };

  const EditarContato = async (
    values: any,
    { setSubmitting }: any
  ) => {
    const request = {
      bancoId: bancoId,
      ...values,
    };
    const response = await BancoController.Atualizar(request);

    if (response.StatusCode === 204) {
      toast('Banco atualizado com sucesso!', {
        type: 'success',
      });
    } else {
      toast('Erro ao atualizar o banco!', {
        type: 'error',
      });
    }

    setSubmitting(false);
  };

  const initialValues = {
    UsuId: userId,
    Descricao: single?.ban_descricao || '',
  };

  const validationSchema = Yup.object().shape({
    Descricao: Yup.string()
      .required('Campo Obrigatorio!')
      .min(4, 'O Campo deve ter no minimo 4 caracteres'),
  });

  return (
    <Box
      sx={{
        '& .MuiTextField-root': { m: 1, width: '35ch' },
      }}
    >
      <HeaderComponent text={'CADASTRO DE BANCOS'} className={'mb-5'} />

      <Formik
        enableReinitialize={true}
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({ errors }: any) => (
          <Form>
            <BoxButtons>
              <Button
                type='button'
                variant='contained'
                onClick={() => navigate(-1)}
                color='warning'
                startIcon={<Icon.ArrowBack />}
              >
                Voltar
              </Button>
              <Button
                type={'submit'}
                variant='contained'
                color='success'
                startIcon={<Icon.Save />}
                disabled={duploClick}
              >
                Salvar
              </Button>
            </BoxButtons>
            <fieldset disabled={duploClick}>
              <Field
                name='Descricao'
                required
                as={TextField}
                label='Descricao'
                placeholder=''
                type='text'
                error={Boolean(errors?.Descricao)}
                helperText={errors?.Descricao}
              />
            </fieldset>
          </Form>
        )}
      </Formik>
    </Box>
  );
}
